import React, { useState, useEffect } from 'react';
import CourseData from '../../../data/course/CourseData.json';
import CourseTypeOne from '../home02/CourseTypeOne';

const CourseTypeFilter = ({ itemToShow }) => {
    const FilterControls = [...new Set(CourseData.map(item => item.filterParam))];
    FilterControls.unshift('All');
    
    const numberOfCourses = itemToShow || 17;
    const [dataVisibleCount] = useState(numberOfCourses);

    const [activeFilter, setActiveFilter] = useState('');
    const [visibleItems, setVisibleItems] = useState([]);
    useEffect(() => {
        setActiveFilter(FilterControls[0].toLowerCase());
        setVisibleItems(CourseData.filter((item) => item.id <= dataVisibleCount));
    }, []);

    const handleChange = (e) => {
        e.preventDefault();
        setActiveFilter(e.target.textContent.toLowerCase());
        let tempData;
        if (e.target.textContent.toLowerCase() === FilterControls[0].toLowerCase()) {
            tempData = CourseData.filter((data) => data.id <= dataVisibleCount);
        } else {
            tempData = CourseData.filter((data) => data.filterParam.toLowerCase() === e.target.textContent.toLowerCase() &&
            data.id <= dataVisibleCount);
        }
        setVisibleItems(tempData);
    }

    // Group courses by their type based on title content
    const groupCourses = () => {
        const generalCourses = visibleItems.filter(item => item.title.startsWith('General'));
        const toeflCourses = visibleItems.filter(item => item.title.includes('TOEFL'));
        const ieltsCourses = visibleItems.filter(item => item.title.includes('IELTS'));
        const j1Courses = visibleItems.filter(item => item.title.includes('English Preparation'));
        const duoLingoCourses = visibleItems.filter(item => item.title.includes('Duolingo'));
        const iPassCourses = visibleItems.filter(item => item.title.includes('iPass'))
        const otherCourses = visibleItems.filter(item => 
            !item.title.startsWith('General') && 
            !item.title.includes('TOEFL') && 
            !item.title.includes('IELTS') &&
            !item.title.includes('Duolingo')&&
            !item.title.includes('English Preparation')&&
            !item.title.includes('iPass')
        );

        return {
            generalCourses,
            toeflCourses,
            ieltsCourses,
            j1Courses,
            duoLingoCourses,
            iPassCourses,
            otherCourses
        };
    };

    const { generalCourses, toeflCourses, ieltsCourses, j1Courses, duoLingoCourses, iPassCourses, otherCourses } = groupCourses();

    return (
        <>
            <div className="container">
                <div className="row align-items-center justify-content-center">
                    <div className="col-lg-12">
                        <div className="heading text-center mb-40">
                            <h2 className="font-lg">Our Courses</h2>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    {generalCourses.length > 0 && (
                        <>
                            <div>
                                <h3 className='m-3'>General English</h3>
                                <hr />
                            </div>
                            {generalCourses.map((item) => (
                                <div className="col-lg-4 col-md-6 col-sm-6" key={item.id}>
                                    <CourseTypeOne data={item} />
                                </div>
                            ))}
                        </>
                    )}
                    
                    
                    {ieltsCourses.length > 0 && (
                        <>
                            <div id='ielts'>
                                <h3 className='m-3'>IELTS</h3>
                                <hr />
                            </div>
                            {ieltsCourses.map((item) => (
                                <div className="col-lg-4 col-md-6 col-sm-6" key={item.id}>
                                    <CourseTypeOne data={item} />
                                </div>
                            ))}
                        </>
                    )}

                    {j1Courses.length > 0 && (
                        <>
                            <div id='ielts'>
                                <h3 className='m-3'>English Preparation For J1</h3>
                                <hr />
                            </div>
                            {j1Courses.map((item) => (
                                <div className="col-lg-4 col-md-6 col-sm-6" key={item.id}>
                                    <CourseTypeOne data={item} />
                                </div>
                            ))}
                        </>
                    )}                    

                    {toeflCourses.length > 0 && (
                        <>
                            <div id='toefl'>
                                <h3 className='m-3'>TOEFL</h3>
                                <hr />
                            </div>
                            {toeflCourses.map((item) => (
                                <div className="col-lg-4 col-md-6 col-sm-6" key={item.id}>
                                    <CourseTypeOne data={item} />
                                </div>
                            ))}
                        </>
                    )}

                    {duoLingoCourses.length > 0 && (
                        <>
                            <div id='duolingo'>
                                <h3 className='m-3'>Duolingo</h3>
                                <hr />
                            </div>
                            {duoLingoCourses.map((item) => (
                                <div className="col-lg-4 col-md-6 col-sm-6" key={item.id}>
                                    <CourseTypeOne data={item} />
                                </div>
                            ))}
                        </>
                    )}

                    {iPassCourses.length > 0 && (
                        <>
                            <div id='ipass'>
                                <h3 className='m-3'>iPass</h3>
                                <hr />
                            </div>
                            {iPassCourses.map((item) => (
                                <div className="col-lg-4 col-md-6 col-sm-6" key={item.id}>
                                    <CourseTypeOne data={item} />
                                </div>
                            ))}
                        </>
                    )}
                    
                    {otherCourses.length > 0 && (
                        <>
                            <div>
                                <h3 className='m-3'>Other Courses</h3>
                                <hr />
                            </div>
                            {otherCourses.map((item) => (
                                <div className="col-lg-4 col-md-6 col-sm-6" key={item.id}>
                                    <CourseTypeOne data={item} />
                                </div>
                            ))}
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default CourseTypeFilter;